module.exports = __webpack_public_path__ + "img/mm-bg.1a2fa594.png";